import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CtNavKeys } from '@cloud-twin-v2/navigation/ct-nav-keys';
import { AuthGuard } from '@common-modules/shared/auth/services/auth.guard';
import { CtMapPageComponent } from './ct-map-page/ct-map-page.component';

const routes: Routes = [
  {
    path: '',
    component: CtMapPageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.Map,
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CtMapRoutingModule {}
